/**
 * @fileoverview Input - Public API
 */
export { Input, type InputProps } from "./input";
